import { P2TextDescription } from "react-bootstrap-common-script"

interface SectionLoaderProps extends React.HtmlHTMLAttributes<HTMLDivElement>{
  
}

function SectionLoader({...props}:SectionLoaderProps) {
  
  return (
    <div style={{...props.style}} className='d-flex flex-column justify-content-center align-items-center gap-4'>
      <P2TextDescription size='20px' color='#333' title={"Preparing documents..."}/>
    </div>
  )
}

export default SectionLoader